import React from 'react';
import {
    Checkbox,
    TableBody,
    TableRow,
    TableCell
} from 'material-ui';

const TableUserPermissionsInputs = ({
    userId,
    groupedPermissions,
    userPermissionsIds,
    classes
}) => {
    return (
        <TableBody>
            <TableRow className={classes.tablePermissionsRow}>
                {groupedPermissions.map(groupedPerm => {
                    return (
                        <TableCell key={groupedPerm.id} className={classes.userPermissions}>
                            {groupedPerm.permissions.map(permission => {
                                const isChecked = userPermissionsIds.includes(permission.id);
                                return (
                                    <div key={permission.id}>
                                        <div className={classes.alignCheckboxes}>
                                            <Checkbox
                                                checked={isChecked}
                                                className={classes.disabledCheckbox}
                                                disabled={true}
                                                name={'group[' + groupedPerm.id + ']perm[' + permission.id + ']'}
                                            />
                                        </div>
                                        <div className={classes.alignText}>{permission.permission_name}</div>
                                    </div>
                                )
                            })}
                        </TableCell>
                    )
                })}
            </TableRow>
        </TableBody>
    )
}

export default TableUserPermissionsInputs;


// WEBPACK FOOTER //
// ./src/containers/users/forms/TableUserPermissionsInputs.jsx